import { isOngoingWorkoutActivity } from '../../utils/activityStatus';
import { todayActivityId } from './todayNextAction';

// Actions already belong to the canonical personal viewer/day snapshot. Only
// a matching owner's live feed result may supersede it before the read settles.
export function ongoingShortcutWorkoutId(actions, activities, cancelledId, now) {
  const canonical = actions.find(action => action.kind === 'resume')?.activity;
  if (!canonical || String(canonical._id) === cancelledId) return null;
  const owner = activity => String(activity.user_id?._id || activity.user_id || '');
  const live = activities.find(activity => todayActivityId(activity) === todayActivityId(canonical)
    && owner(activity) === owner(canonical));
  return isOngoingWorkoutActivity(live || canonical, now) ? todayActivityId(canonical) : null;
}
